import { render, staticRenderFns } from "./ModalListaSubFase.vue?vue&type=template&id=5a199190"
import script from "./ModalListaSubFase.vue?vue&type=script&lang=js"
export * from "./ModalListaSubFase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports